import { render, staticRenderFns } from "./LogisticssPop.vue?vue&type=template&id=43360907&scoped=true"
import script from "./LogisticssPop.vue?vue&type=script&lang=js"
export * from "./LogisticssPop.vue?vue&type=script&lang=js"
import style0 from "./LogisticssPop.vue?vue&type=style&index=0&id=43360907&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43360907",
  null
  
)

export default component.exports